import {schemaHash, type DescMessage} from '@github-ui/dotcom-schema/protobuf'
import {hashKey, type QueryKey} from '@tanstack/react-query'

export function getPersisterStorageKey({prefix, queryKey}: {prefix: string; queryKey: QueryKey}) {
  return `${prefix}-${hashKey(queryKey)}`
}

export function getProtoPersisterPrefix(schema: DescMessage, prefix = 'proto') {
  return `${prefix}::${schemaHash(schema)}`
}

export function getProtoPersisterStorageKey({
  schema,
  prefix = 'proto',
  queryKey,
}: {
  schema: DescMessage
  prefix?: string
  queryKey: QueryKey
}) {
  return getPersisterStorageKey({prefix: getProtoPersisterPrefix(schema, prefix), queryKey})
}
